import { connect } from 'react-redux';

import type {
  ImageOptionDispatchProps,
  ImageOptionProps,
} from 'src/components/organisms/Personalisation/components/ImageOption/ImageOption';
import { ImageOption } from 'src/components/organisms/Personalisation/components/ImageOption/ImageOption';
import { selectOutstandingOptions, selectSelectedOption } from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/product/selectors';

type OwnProps = Pick<ImageOptionProps, 'displayValidation' | 'forwardedRef' | 'option'>;

/** Redux selection and min/max (`imageOptionBounds(ownProps.option)`) are scoped per catalogue `option.id`. */
const mapStateToProps = (state: ReduxApplicationState, ownProps: OwnProps) => ({
  error:
    Boolean(ownProps.displayValidation) &&
    selectOutstandingOptions(state).some((opt) => opt.id === ownProps.option.id),
  productCode: selectProduct(state).code,
  selectedValues: selectSelectedOption(state, ownProps.option.id),
});

const mapDispatchToProps: ImageOptionDispatchProps = {
  selectOption: basketActions.selectOption,
  trackImageUploadAttempt: basketActions.trackImageUploadAttempt,
  trackImageUploadError: basketActions.trackImageUploadError,
  trackRequiredImageOptionImpression: basketActions.trackRequiredImageOptionImpression,
};

export const ImageOptionContainer = connect(mapStateToProps, mapDispatchToProps)(ImageOption);
